const textFasilitasKesehatan = {
	FASILITAS_KESEHATAN: {
		PAGE_GREETING: 'Fasilitas Kesehatan',
		PAGE_GREETING_DESC: 'Silakan lengkapi data berikut dan sertakan tujuan kerja sama',
	},
	ALPHABET: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
};

export default textFasilitasKesehatan;
